import { render } from "./LocalStateInfo.vue?vue&type=template&id=18ff54bc&scoped=true&ts=true"
import script from "./LocalStateInfo.vue?vue&type=script&lang=ts"
export * from "./LocalStateInfo.vue?vue&type=script&lang=ts"

import "./LocalStateInfo.vue?vue&type=style&index=0&id=18ff54bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18ff54bc"]])

export default __exports__